module.exports = __webpack_public_path__ + "img/pagetitle-bg.e989177a.jpg";